var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/load_gap.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Icon from 'soapbox/components/icon';
const messages = defineMessages({
  load_more: {
    "id": "status.load_more",
    "defaultMessage": "Load more"
  }
});
const LoadGap = ({
  disabled,
  maxId,
  onClick
}) => {
  const intl = useIntl();
  const handleClick = () => onClick(maxId);
  return /*#__PURE__*/React.createElement("button", {
    className: "load-more load-gap",
    disabled: disabled,
    onClick: handleClick,
    "aria-label": intl.formatMessage(messages.load_more),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/dots.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }));
};
export default LoadGap;